"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUUID = void 0;
// Polyfill for UUID generation, adapted from https://stackoverflow.com/a/8809472
// can be safely removed once global usage of supported browsers is above an acceptable treshold
// https://caniuse.com/?search=randomUUID
const generateUUID = () => {
    let d = new Date().getTime(), d2 = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        }
        else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c == 'x' ? r : (r & 0x7) | 0x8).toString(16);
    });
};
exports.generateUUID = generateUUID;
//# sourceMappingURL=Utils.js.map